







import Vue from 'vue'
import props from '../themeProps'

export default Vue.extend({ props })



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/theme/vanilla/Selection.vue